export const comics = [
  {
    id: 1,
    title: "我独自升级",
    slug: "solo-leveling",
    author: "Chugong / Jang Sung-rak",
    category: "热血",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20solo%20leveling%20style%20warrior%20character%20dark%20fantasy%20illustration%20with%20purple%20and%20black%20color%20scheme%20dynamic%20pose%20epic%20atmosphere%20manga%20art%20style%20cover%20design&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    description: "十年前，世界与其他次元连接后出现了「传送门」，同时有部分人类觉醒了超能力，被称为「猎人」。身为最低等级猎人的成肖宇，在某次探索低级传送门时被卷入意外，重伤濒死之际，眼前突然出现了一个神秘的 Quest 窗口…",
    rating: 9.7,
    views: 2850000,
    chapters: 179,
    status: "已完结",
    updateDate: "2026-08-01",
    tags: ["战斗", "奇幻", "逆袭", "系统流"],
    relatedIds: [2, 5, 8],
  },
  {
    id: 2,
    title: "剑尊归来",
    slug: "return-of-sword-master",
    author: "LEE Seung-ho / REDICE STUDIO",
    category: "热血",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20sword%20master%20martial%20arts%20character%20in%20traditional%20hanbok%20holding%20sword%20ancient%20Chinese%20inspired%20setting%20dramatic%20lighting%20manga%20art%20style%20epic%20cover&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    description: "被誉为天下第一剑的梅东秀，在与魔教教主的大战之后陨落，醒来时发现自己变成了一个普通门派的外门弟子。带着前世的记忆与剑术，他决定重新踏上武道巅峰之路。",
    rating: 9.5,
    views: 2100000,
    chapters: 156,
    status: "连载中",
    updateDate: "2026-08-03",
    tags: ["武侠", "修仙", "逆袭", "战斗"],
    relatedIds: [1, 6, 10],
  },
  {
    id: 3,
    title: "她的私生活",
    slug: "her-private-life",
    author: "KIM Sung-yeon",
    category: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20young%20couple%20in%20modern%20Seoul%20cityscape%20background%20warm%20pink%20and%20pastel%20tone%20soft%20lighting%20shojo%20manga%20style%20romantic%20illustration&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    description: "姜敏珠是一名博物馆策展人，表面上是个完美的职场女性，但私下里却是一个狂热的偶像粉丝。当她的新上司发现了她的秘密身份后，两人的关系变得微妙起来...",
    rating: 9.2,
    views: 1560000,
    chapters: 88,
    status: "已完结",
    updateDate: "2026-07-25",
    tags: ["职场", "偶像", "甜蜜", "都市"],
    relatedIds: [7, 12, 15],
  },
  {
    id: 4,
    title: "全知读者视角",
    slug: "omniscient-reader",
    author: "sing N song / Sleepy-C",
    category: "奇幻",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20omniscient%20reader%20viewpoint%20style%20apocalyptic%20fantasy%20protagonist%20with%20mysterious%20aura%20dark%20urban%20setting%20constellation%20theme%20dramatic%20composition%20manga%20art&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    description: "金独子是一个普通的上班族，唯一特别的爱好是阅读一本长达3149章的网络小说。当小说迎来最终话的那天，小说中的世界竟然变成了现实，而他成了唯一知道这个世界结局的人。",
    rating: 9.8,
    views: 3200000,
    chapters: 210,
    status: "连载中",
    updateDate: "2026-08-04",
    tags: ["末世", "系统流", "智斗", "奇幻"],
    relatedIds: [1, 8, 11],
  },
  {
    id: 5,
    title: "某天成为公主",
    slug: "who-made-me-a-princess",
    author: "Plutus / Spoon",
    category: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20princess%20character%20in%20elegant%20Victorian%20dress%20golden%20blonde%20hair%20palace%20background%20fantasy%20royalty%20theme%20sparkling%20atmosphere%20shojo%20style%20beautiful%20illustration&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    description: "某天醒来，我发现自己变成了小说中的公主——但不是女主角，而是在故事开头就被自己亲生父亲处死的悲情配角。为了活下去，我决定远离那个冷酷的皇帝父亲，但事情好像没有那么简单...",
    rating: 9.4,
    views: 1890000,
    chapters: 125,
    status: "已完结",
    updateDate: "2026-07-30",
    tags: ["穿越", "父女", "宫廷", "治愈"],
    relatedIds: [3, 13, 14],
  },
  {
    id: 6,
    title: "废柴皇子的逆袭",
    slug: "trash-prince-revenge",
    author: "Park Jung-joon / Studio JHS",
    category: "热血",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20haired%20prince%20character%20in%20regal%20attire%20brooding%20expression%20medieval%20castle%20background%20revenge%20theme%20intense%20gaze%20dramatic%20shadow%20manga%20art%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    description: "作为帝国的第七皇子，艾德里安因为生母低微，一直被其他皇子欺负。在一次意外中获得上古龙族传承后，他开始踏上夺嫡之路，誓要让所有看不起他的人付出代价。",
    rating: 9.1,
    views: 1450000,
    chapters: 98,
    status: "连载中",
    updateDate: "2026-08-02",
    tags: ["宫廷", "权谋", "逆袭", "魔法"],
    relatedIds: [2, 9, 10],
  },
  {
    id: 7,
    title: "女神降临",
    slug: "true-beauty",
    author: "Yaongyi",
    category: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20beautiful%20young%20woman%20with%20makeup%20transformation%20theme%20before%20and%20after%20concept%20school%20drama%20setting%20soft%20pastel%20colors%20shojo%20style%20illustration&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    description: "林珠京因为外貌在学校备受欺凌。转学后，她通过化妆技巧华丽变身为校园女神，过上了完全不同的人生。但当两个男生同时发现她的秘密时，她的双重生活开始动摇...",
    rating: 9.3,
    views: 2400000,
    chapters: 210,
    status: "已完结",
    updateDate: "2026-07-20",
    tags: ["校园", "化妆", "成长", "三角恋"],
    relatedIds: [3, 5, 15],
  },
  {
    id: 8,
    title: "重生之神级天赋",
    slug: "reborn-god-talent",
    author: "KANG Min-woo / Piccomics",
    category: "奇幻",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20reborn%20character%20with%20magical%20powers%20glowing%20energy%20surrounding%20hands%20mystical%20gate%20portal%20background%20dungeon%20theme%20vibrant%20colors%20action%20pose%20manga%20style&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    description: "最强猎人在与终极魔王的战斗中陨落，却带着全部记忆重生回到了二十年前。这一次，他决定利用前世的所有经验，从最初就踏上最完美的修炼之路。",
    rating: 9.6,
    views: 1980000,
    chapters: 145,
    status: "连载中",
    updateDate: "2026-08-04",
    tags: ["重生", "爽文", "战斗", "升级流"],
    relatedIds: [1, 4, 11],
  },
  {
    id: 9,
    title: "医生回归",
    slug: "doctor-return",
    author: "LEE Dong-wook / JT Studio",
    category: "热血",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20doctor%20character%20in%20white%20coat%20holding%20scalpel%20intense%20serious%20expression%20modern%20hospital%20setting%20with%20dramatic%20lighting%20medical%20drama%20theme%20manga%20art%20style&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    description: "被誉为「神之手」的外科医生金俊秀，在一次医疗事故后被吊销执照。就在人生最低谷时，他的手突然被一道神秘的光芒笼罩，获得了超凡的医术能力，从此开始了一段传奇的复仇与救赎之路。",
    rating: 9.0,
    views: 1120000,
    chapters: 67,
    status: "连载中",
    updateDate: "2026-08-01",
    tags: ["现代", "医疗", "逆袭", "都市"],
    relatedIds: [2, 6, 10],
  },
  {
    id: 10,
    title: "剑道第一仙",
    slug: "first-immortal-sword",
    author: "CHOI Min-suk",
    category: "奇幻",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20immortal%20cultivator%20with%20floating%20swords%20ancient%20oriental%20mountaintop%20setting%20clouds%20and%20mist%20celestial%20atmosphere%20golden%20and%20white%20color%20scheme%20epic%20fantasy%20illustration&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    description: "少年叶尘偶然获得上古剑仙传承，从此踏上剑道修行之路。在这个修仙者横行的世界中，他以一柄铁剑闯荡天下，斩妖除魔，一步步走向剑道巅峰。",
    rating: 9.2,
    views: 1680000,
    chapters: 188,
    status: "连载中",
    updateDate: "2026-08-03",
    tags: ["修仙", "剑道", "战斗", "东方玄幻"],
    relatedIds: [2, 6, 9],
  },
  {
    id: 11,
    title: "作家的秘密",
    slug: "writer-secret",
    author: "HAN Soo-young",
    category: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20mysterious%20writer%20character%20at%20desk%20with%20old%20typewriter%20dark%20room%20with%20single%20light%20source%20creepy%20atmosphere%20psychological%20horror%20theme%20dramatic%20composition%20manga%20style&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    description: "畅销推理小说作家赵恩浩的最新作品引起了轰动，因为书中描绘的谋杀案竟然在现实中一一上演。警方的调查逐渐指向了一个惊人的可能性：要么作者就是凶手，要么有人正在按照他书中的内容实施犯罪。",
    rating: 9.3,
    views: 1350000,
    chapters: 56,
    status: "连载中",
    updateDate: "2026-08-02",
    tags: ["推理", "悬疑", "犯罪", "心理"],
    relatedIds: [4, 8, 16],
  },
  {
    id: 12,
    title: "甜蜜的陷阱",
    slug: "sweet-trap",
    author: "PARK Min-ji",
    category: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20beautiful%20brunette%20woman%20and%20handsome%20man%20at%20cafe%20coffee%20shop%20setting%20warm%20cozy%20atmosphere%20autumn%20leaves%20outside%20window%20sweet%20romantic%20shojo%20style&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    description: "咖啡店老板林素英的生活被一位神秘顾客彻底打乱了。这位每天准时出现的英俊男子，似乎隐藏着不为人知的秘密。当她发现自己卷入了一场精心设计的爱情陷阱时，一切都已经来不及了。",
    rating: 8.9,
    views: 980000,
    chapters: 72,
    status: "已完结",
    updateDate: "2026-07-15",
    tags: ["咖啡店", "秘密", "都市爱情", "治愈"],
    relatedIds: [3, 7, 15],
  },
  {
    id: 13,
    title: "恶魔的摇篮曲",
    slug: "devil-lullaby",
    author: "JUNG Min-ah / REDICE STUDIO",
    category: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20gothic%20horror%20theme%20mysterious%20girl%20with%20long%20black%20hair%20in%20white%20dress%20haunted%20mansion%20background%20moonlight%20through%20window%20eerie%20atmosphere%20dark%20art%20style&width=600&height=800&seq=comic-cover-13&orientation=portrait",
    description: "搬到乡下老宅的少女李美娜，每到午夜就会听到诡异的摇篮曲。随着调查的深入，她发现这座宅子里隐藏着一个跨越百年的诅咒，而摇篮曲正是揭开谜团的关键。",
    rating: 9.1,
    views: 870000,
    chapters: 45,
    status: "连载中",
    updateDate: "2026-08-01",
    tags: ["恐怖", "诅咒", "灵异", "悬疑"],
    relatedIds: [11, 16, 18],
  },
  {
    id: 14,
    title: "最强外卖员",
    slug: "strongest-delivery",
    author: "KIM Tae-hyun",
    category: "搞笑",
    cover: "https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20delivery%20rider%20on%20scooter%20with%20exaggerated%20action%20pose%20modern%20Seoul%20city%20streets%20background%20funny%20dynamic%20illustration%20bright%20colorful%20cartoon%20style&width=600&height=800&seq=comic-cover-14&orientation=portrait",
    description: "兼职外卖员金哲秀本来是平凡的大学生，却在某次送餐途中意外获得了「瞬间移动」的超能力。从此，他成了全城最快的外卖员，但也因此被卷入了各种离谱又搞笑的事件中。",
    rating: 9.0,
    views: 1100000,
    chapters: 85,
    status: "连载中",
    updateDate: "2026-08-03",
    tags: ["超能力", "日常", "搞笑", "都市"],
    relatedIds: [5, 9, 17],
  },
  {
    id: 15,
    title: "海王的忏悔",
    slug: "playboy-confession",
    author: "YOON Jae-min",
    category: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20manhwa%20handsome%20man%20surrounded%20by%20multiple%20women%20silhouettes%20dramatic%20lighting%20modern%20nightclub%20setting%20neon%20lights%20relationship%20drama%20theme%20shojo%20style%20illustration&width=600&height=800&seq=comic-cover-15&orientation=portrait",
    description: "姜泰浩是公认的花花公子，同时交往多个女友从不翻车。但某一天，他所有的女友约好在同一时间同一地点见面，一场关于爱情与谎言的修罗场正式拉开帷幕。",
    rating: 8.8,
    views: 1250000,
    chapters: 60,
    status: "已完结",
    updateDate: "2026-07-10",
    tags: ["修罗场", "都市", "恋爱", "搞笑"],
    relatedIds: [7, 12, 3],
  },
  {
    id: 16,
    title: "禁忌之书",
    slug: "forbidden-book",
    author: "YOO Ji-hoon / Studio MWP",
    category: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20manhwa%20ancient%20book%20glowing%20with%20mysterious%20light%20dusty%20library%20setting%20old%20bookshelves%20cobwebs%20dark%20atmosphere%20occult%20theme%20dramatic%20horror%20art%20style&width=600&height=800&seq=comic-cover-16&orientation=portrait",
    description: "大学图书馆管理员在整理旧书时，发现了一本没有登记编码的古书。翻开书页的瞬间，书中的文字开始自动书写，记录的全是即将发生的死亡事件。而他每次试图改变预言，都会导致更可怕的结果。",
    rating: 9.4,
    views: 1020000,
    chapters: 38,
    status: "连载中",
    updateDate: "2026-08-04",
    tags: ["超自然", "预言", "惊悚", "悬疑"],
    relatedIds: [11, 13, 18],
  },
  {
    id: 17,
    title: "我的同桌是大神",
    slug: "god-desk-mate",
    author: "SONG Ji-eun",
    category: "搞笑",
    cover: "https://readdy.ai/api/search-image?query=Korean%20school%20comedy%20manhwa%20two%20high%20school%20students%20at%20desk%20one%20with%20glowing%20divine%20aura%20other%20surprised%20expression%20classroom%20setting%20sunny%20day%20light%20rays%20through%20window%20funny%20cartoon%20style&width=600&height=800&seq=comic-cover-17&orientation=portrait",
    description: "普通高中生朴在元的新同桌竟然是一个转世的天神！然而这位大神因为失去了大部分神力，现在只能靠微弱的法术在日常生活中制造各种乌龙。一场神仙与凡人的搞笑校园日常就此展开。",
    rating: 8.7,
    views: 760000,
    chapters: 52,
    status: "连载中",
    updateDate: "2026-07-28",
    tags: ["校园", "神仙", "搞笑", "日常"],
    relatedIds: [14, 7, 5],
  },
  {
    id: 18,
    title: "第七日的审判",
    slug: "seventh-day-judgment",
    author: "KIM Dong-hyun",
    category: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20manhwa%20detective%20character%20in%20trench%20coat%20standing%20in%20rainy%20alleyway%20neon%20signs%20reflection%20on%20wet%20ground%20noir%20atmosphere%20mystery%20investigation%20theme%20dramatic%20cinematic%20style&width=600&height=800&seq=comic-cover-18&orientation=portrait",
    description: "连续六起命案，被害者都是曾经逃脱法律制裁的罪犯。探员崔尚赫在追查这个神秘连环杀手时，发现所有线索都指向七年前的某桩冤案。第七天即将到来，最后的目标到底是谁？",
    rating: 9.5,
    views: 920000,
    chapters: 42,
    status: "连载中",
    updateDate: "2026-08-03",
    tags: ["犯罪", "复仇", "悬疑", "刑侦"],
    relatedIds: [11, 13, 16],
  },
];

export const categories = [
  { name: "全部", slug: "all", icon: "ri-apps-2-line", count: 18 },
  { name: "热血", slug: "action", icon: "ri-fire-line", count: 4 },
  { name: "恋爱", slug: "romance", icon: "ri-heart-line", count: 5 },
  { name: "奇幻", slug: "fantasy", icon: "ri-magic-line", count: 3 },
  { name: "悬疑", slug: "thriller", icon: "ri-search-eye-line", count: 4 },
  { name: "搞笑", slug: "comedy", icon: "ri-emotion-laugh-line", count: 2 },
];

export const banners = [
  {
    id: 1,
    title: "全知读者视角",
    subtitle: "全网最火 · 9.8分神作",
    description: "当小说变成现实，唯一知道结局的他能否改变命运？",
    comicId: 4,
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20epic%20fantasy%20banner%20style%20apocalyptic%20cityscape%20with%20constellations%20in%20night%20sky%20dramatic%20silhouette%20of%20protagonist%20standing%20on%20rooftop%20dark%20atmosphere%20with%20golden%20accents%20cinematic%20composition%20manga%20aesthetic&width=1600&height=700&seq=banner-01&orientation=landscape",
  },
  {
    id: 2,
    title: "我独自升级",
    subtitle: "经典必读 · 9.7分口碑",
    description: "从最低级猎人开始的逆天之路",
    comicId: 1,
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20fantasy%20banner%20dungeon%20portal%20theme%20warrior%20character%20with%20glowing%20purple%20energy%20epic%20battle%20atmosphere%20ruins%20background%20dramatic%20lighting%20manga%20style%20cinematic%20wide%20composition&width=1600&height=700&seq=banner-02&orientation=landscape",
  },
  {
    id: 3,
    title: "剑尊归来",
    subtitle: "武侠巅峰 · 9.5分力作",
    description: "天下第一剑，重生再临武道巅峰",
    comicId: 2,
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20fantasy%20banner%20ancient%20oriental%20mountain%20landscape%20with%20cherry%20blossoms%20sword%20master%20character%20in%20traditional%20robes%20dramatic%20wind%20effect%20epic%20cinematic%20composition%20manga%20style&width=1600&height=700&seq=banner-03&orientation=landscape",
  },
];

export const faqs = [
  {
    question: "韩漫大全网站上的漫画都是免费的吗？",
    answer: "是的！韩漫大全平台上的所有漫画资源都完全免费观看。我们的使命就是为广大韩漫爱好者提供一个零门槛、高品质的漫画阅读平台，让每一位用户都能畅享韩国漫画的魅力。",
  },
  {
    question: "韩漫大全网站支持哪些设备阅读？",
    answer: "韩漫大全完美支持PC端、平板和手机端阅读。无论在电脑、iPad还是手机上，都能获得流畅舒适的漫画阅读体验。我们的网站采用响应式设计，自动适配各种屏幕尺寸。",
  },
  {
    question: "韩漫大全的漫画更新频率如何？",
    answer: "我们团队每日追踪韩国各大漫画平台的最新更新，确保在第一时间同步热门漫画的最新章节。一般来说，连载中的热门韩漫会在24小时内完成翻译更新。",
  },
  {
    question: "如何在韩漫大全上找到我想看的漫画？",
    answer: "您可以通过首页的搜索功能直接搜索漫画名称，也可以按分类（热血、恋爱、奇幻、悬疑、搞笑等）浏览。此外，首页的热门推荐和最新更新模块也能帮助您发现优质漫画。",
  },
  {
    question: "韩漫大全是否需要注册账号？",
    answer: "不需要！韩漫大全坚持无门槛阅读理念，所有用户无需注册即可免费观看所有漫画。我们不会设置任何阅读限制或付费墙，真正做到自由阅读。",
  },
];

export const testimonials = [
  {
    name: "漫画迷小明",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%20casual%20style%20friendly%20smile%20simple%20white%20background%20studio%20lighting%20clean%20avatar%20photo&width=100&height=100&seq=avatar-01&orientation=squarish",
    comment: "追了两年韩漫，这个平台真的是我用过最好的！更新超快，分类也很全，每天刷一刷都有新发现。",
    rating: 5,
  },
  {
    name: "二次元少女",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20sweet%20smile%20natural%20makeup%20simple%20white%20background%20soft%20lighting%20clean%20professional%20avatar%20photo&width=100&height=100&seq=avatar-02&orientation=squarish",
    comment: "恋爱类韩漫超全！终于找到一个能让我安心追《女神降临》的地方了，画质也很好。",
    rating: 5,
  },
  {
    name: "热血达人",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20man%20portrait%20confident%20expression%20short%20hair%20casual%20black%20t-shirt%20simple%20white%20background%20clean%20studio%20photography%20avatar&width=100&height=100&seq=avatar-03&orientation=squarish",
    comment: "热血战斗类太爽了！《我独自升级》就是在这里追完的，翻译质量也在线，强烈推荐！",
    rating: 5,
  },
];

export const siteConfig = {
  name: "韩漫大全",
  tagline: "免费看韩漫网站 - 韩漫大全平台",
  description: "韩漫大全是一个免费观看韩国漫画的综合平台，提供热血、恋爱、奇幻、悬疑、搞笑等全类型韩漫。每日更新，无需注册，免费阅读，打造最全韩漫资源库。",
  keywords: "韩漫,免费韩漫,韩漫网站,韩国漫画,免费看韩漫,韩漫大全,漫画在线阅读,热血韩漫,恋爱韩漫",
  url: "https://www.hanmandaquan.com",
  ogImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20platform%20website%20open%20graph%20image%20colorful%20comic%20book%20style%20background%20with%20various%20manga%20characters%20collage%20vibrant%20colors%20modern%20design%20text%20space%20in%20center%20Korean%20webtoon%20aesthetic&width=1200&height=630&seq=og-image&orientation=landscape",
};